import { getSession } from "@iewccouk/Services/SessionService";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { chain, RequestDataFromApi } from "@insite/client-framework/Store/Context/Handlers/LoadSession";

replaceInChain(chain, RequestDataFromApi, async props => {
    props.apiResult = await getSession(props.apiParameter);
});
